export default {
    login: { method: 'post', url: 'v2/movida/user/login' },
    loadSession: { method: 'get', url: 'v1/movida/user/show' },
    app: { method: 'post', url: 'v1/movida/application/login' },
    forgotPassword: { method: 'post', url: 'v1/movida/user/code-reset-password'},
    resetPassword: { method: 'post', url: 'v1/movida/user/reset-password{?code}'}
}
